import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-sticky-el';
import ReactTooltip from 'react-tooltip';
import classes from './Today.scss';
import TaskList from '../TaskList';
import Activity from '../Activity/Activity';
import moment from 'moment';
import ContactCard from '../ContactCard/ContactCard';
import FormActivity from '../FormActivity/FormActivity';
import ic_task_future from '../../assets/ic-task-future.svg';
import ic_task_nulldate from '../../assets/ic-task-nulldate.svg';
import OvalIcon from '../../assets/ic_oval.svg';
import InlineSVG from 'svg-inline-react';

require('moment/locale/de');

export class Today extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newTask: '',
      showNullDueDates: true,
      showFutureDates: false,
    };

    moment.locale('de');
  }

  componentDidMount() {
    const showNullDueDates = localStorage.getItem('showNullDueDates');
    if (showNullDueDates === 'false' || showNullDueDates === false) {
      this.setState({ showNullDueDates: false });
    }

    const showFutureDates = localStorage.getItem('showFutureDates');
    if (showFutureDates === 'false' || showFutureDates === false) {
      this.setState({ showFutureDates: false });
    }
  }

  createNewTask = event => {
    this.setState({ newTask: event.target.value });

    if (event.keyCode === 13) {
      // console.log('saving task');
      this.props.saveTask({ title: this.state.newTask });
      this.setState({ newTask: '' });
    }
  };

  renderActivities = () => {
    const activities = this.props.activities.map(data => (
      <Activity
        activity={data}
        displayMode="today"
        key={`today_activity_${data.id}`}
      />
    ));

    if (activities.length) {
      return activities;
    }
    return (
      <div>
        <p className="text-center">
          <small>Keine Aktivitäten eingetragen.</small>
        </p>
      </div>
    );
  };

  renderHeader = () => {
    let heading = 'Heute';

    if (!this.props.today.isSame(moment(), 'day')) {
      // was done today
      heading = this.props.today.format('dddd, DD.MM.YYYY');
    }

    const header = (
      <header>
        <div
          className={classes.prev}
          onClick={() =>
            this.props.changeDay(this.props.today.subtract(1, 'days'))
          }
        />
        {heading}
        <div
          className={classes.next}
          onClick={() => this.props.changeDay(this.props.today.add(1, 'days'))}
        />
      </header>
    );

    if (window.innerWidth < 767) {
      return header;
    }

    return <Sticky scrollElement="#scroller">{header}</Sticky>;
  };

  renderBirthdays = () => {
    const birthdays = [];

    this.props.staff.forEach(data => {
      let birthday = moment(data.meta.date_of_birth.value, 'DD.MM.YYYY');
      if (!birthday.isValid()) {
        birthday = moment(data.meta.date_of_birth.value, 'YYYY-MM-DD');
      }

      const nameAgeCombo = `${data.name} wird ${this.props.today.diff(
        birthday,
        'years',
      )} Jahre alt 🎂`;

      birthdays.push(
        <ContactCard
          key={`birthday_staff_${data.id}`}
          id={data.id}
          name={nameAgeCombo}
          type="staff"
        />,
      );
    });

    this.props.persons.forEach(data => {
      let birthday = moment(data.meta.date_of_birth.value, 'DD.MM.YYYY');
      if (!birthday.isValid()) {
        birthday = moment(data.meta.date_of_birth.value, 'YYYY-MM-DD');
      }

      const nameAgeCombo = `${data.name} wird ${this.props.today.diff(
        birthday,
        'years',
      )} Jahre alt 🎂`;

      birthdays.push(
        <ContactCard
          key={`birthday_person_${data.id}`}
          id={data.id}
          name={nameAgeCombo}
          type="person"
        />,
      );
    });

    if (birthdays.length === 0) {
      return <div />;
    }

    return (
      <div className="text-center">
        <h4>
          {birthdays.length} Geburtstag{birthdays.length > 1 ? 'e' : ''} an
          diesem Tag
        </h4>
        {birthdays}
      </div>
    );
  };

  render() {
    return (
      <div className={classes.today}>
        {this.renderHeader()}
        {this.renderBirthdays()}
        <section className={`${classes.section} ${classes.tasks}`}>
          <div className={classes.head}>
            <h3>Meine Aufgaben</h3>
            <div className={classes.showNullDueDates}>
              <label
                data-tip={`Zeige Aufgaben ohne Zieldatum`}
                data-for={`today_tooltip`}
              >
                <input
                  type="checkbox"
                  name="showNullDueDates"
                  checked={this.state.showNullDueDates}
                  onChange={() => {
                    this.setState({
                      showNullDueDates: !this.state.showNullDueDates,
                    });
                    localStorage.setItem(
                      'showNullDueDates',
                      !this.state.showNullDueDates,
                    );
                  }}
                />
                <InlineSVG src={ic_task_nulldate} />
              </label>
              <label
                data-tip={`Zeige zukünftige Aufgaben`}
                data-for={`today_tooltip`}
              >
                <input
                  type="checkbox"
                  name="showFutureDates"
                  checked={this.state.showFutureDates}
                  onChange={() => {
                    this.setState({
                      showFutureDates: !this.state.showFutureDates,
                    });
                    localStorage.setItem(
                      'showFutureDates',
                      !this.state.showFutureDates,
                    );
                  }}
                />
                <InlineSVG src={ic_task_future} />
              </label>
            </div>
          </div>
          <div className={classes.form}>
            <div className={classes.newTask}>
              <input
                type="text"
                placeholder="Aufgabe an mich erstellen"
                value={this.state.newTask}
                onChange={event => this.createNewTask(event)}
                onKeyUp={this.createNewTask}
              />
            </div>
          </div>
          <div className={classes.body}>
            <TaskList
              tasks={this.props.tasks}
              showNullDueDates={this.state.showNullDueDates}
              showFutureDates={this.state.showFutureDates}
            />
          </div>
        </section>
        <section className={`${classes.section} ${classes.activities}`}>
          <div className={classes.head}>
            <h3 className={classes.borderTop}>Aktivitäten</h3>
          </div>
          <div className={classes.form}>
            <FormActivity
              type="embed"
              originalType="embed"
              sidebar
              todayWidget
            />
          </div>
          <div className={classes.body}>{this.renderActivities()}</div>
        </section>
        <ReactTooltip
          id={`today_tooltip`}
          className={classes.tooltip}
          place="bottom"
          type="dark"
          effect="solid"
          html
        />
      </div>
    );
  }
}

Today.propTypes = {
  tasks: PropTypes.array,
  activities: PropTypes.array,
  saveTask: PropTypes.func,
  changeDay: PropTypes.func,
  today: PropTypes.object.isRequired,
  staff: PropTypes.array,
  persons: PropTypes.array,
};

Today.defaultProps = {
  today: moment(),
  tasks: [],
  activities: [],
  staff: [],
  persons: [],
  saveTask: () => {},
  changeDay: () => {},
};

export default Today;



// WEBPACK FOOTER //
// ./src/components/Today/Today.js